<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <router-link to="/waste/typeSolidManage">
          <i-button type="info">一般固废类型管理</i-button>
        </router-link>
        <router-link to="/waste/typeManage">
          <i-button type="info" style="margin-left: 1em;">危废类型管理</i-button>
        </router-link>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="固废名称：" prop="wasteName">
          <i-input v-model="formValidate.wasteName" placeholder="输入固废名称"></i-input>
        </FormItem>
        <FormItem label="固废类别：" prop="wasteTypeName">
          <i-input v-model="formValidate.wasteTypeName" placeholder="输入固废类别"></i-input>
        </FormItem>
        <FormItem label="固废代码：" prop="wasteTypeCode">
          <i-input v-model="formValidate.wasteTypeCode" placeholder="输入固废代码"></i-input>
        </FormItem>
        <FormItem label="废物形态：" prop="wasteForm">
          <i-input v-model="formValidate.wasteForm" placeholder="输入废物形态，如固态、液态等"></i-input>
        </FormItem>
        <FormItem label="主要成分：" prop="mainConstituents">
          <i-input v-model="formValidate.mainConstituents" placeholder="输入主要成分"></i-input>
        </FormItem>
        <FormItem label="注意事项：" prop="notesPrecautions">
          <i-input v-model="formValidate.notesPrecautions" placeholder="输入注意事项"></i-input>
        </FormItem>
        <FormItem label="备注：" prop="comment">
          <i-input v-model="formValidate.comment" type="textarea" :rows="2" placeholder="输入备注"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "一般固废名称",
            key: "wasteName",
            align: "center"
          },
          {
            title: "一般固废类别",
            key: "wasteTypeName",
            align: "center"
          },
          {
            title: "一般固废代码",
            key: "wasteTypeCode",
            width: 160,
            align: "center"
          },
          {
            title: "废物形态",
            key: "wasteForm",
            align: "center"
          },
          {
            title: "主要成分",
            key: "mainConstituents",
            align: "center"
          },
          {
            title: "注意事项",
            key: "notesPrecautions",
            align: "center"
          },
          {
            title: "备注",
            key: "comment",
            align: "center"
          },
          {
            title: "操作",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          wasteName: params.row.wasteName, // 一般固废名称
                          wasteTypeName: params.row.wasteTypeName, // 一般固废类别
                          wasteTypeCode: params.row.wasteTypeCode, // 一般固废代码
                          wasteForm: params.row.wasteForm, // 一般固废形态
                          mainConstituents: params.row.mainConstituents, // 主要成分
                          notesPrecautions: params.row.notesPrecautions, // 注意事项
                          comment: params.row.comment, // 备注
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {},
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        wasteName: "", // 一般固废名称
        wasteTypeName: "", // 一般固废类别
        wasteTypeCode: "", // 一般固废代码
        wasteForm: "", // 废物形态
        mainConstituents: "", // 主要成分
        notesPrecautions: "", // 注意事项
        comment: "", // 备注
      },
      // 验证
      ruleValidate: {
        wasteName: [{ required: true, message: "不能为空", trigger: "blur" }],
        wasteTypeName: [{ required: true, message: "不能为空", trigger: "blur" }],
        wasteTypeCode: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getData(); // 数据初始化
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        wasteName: "", // 一般固废名称
        wasteTypeName: "", // 一般固废类别
        wasteTypeCode: "", // 一般固废代码
        wasteForm: "", // 一般固废形态
        mainConstituents: "", // 主要成分
        notesPrecautions: "", // 注意事项
        comment: "", // 备注
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getWasteSolidTypeManageList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          //content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Waste.getWasteSolidTypeManageDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Waste.postWasteSolidTypeManageAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Waste.postWasteSolidTypeManageEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
  }
};
</script>